import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck, Clock, Award, Mail } from 'lucide-react';
import { comfortImage, comfortImageSmall } from '../data/mock';
import { useLang } from '../context/LanguageContext';

export default function ComfortSection() {
  const { t } = useLang();
  const features = [
    { icon: Award, t: t('comfort.f1.t'), d: t('comfort.f1.d') },
    { icon: Clock, t: t('comfort.f2.t'), d: t('comfort.f2.d') },
    { icon: ShieldCheck, t: t('comfort.f3.t'), d: t('comfort.f3.d') },
  ];
  return (
    <section className="relative bg-white py-24">
      <div className="max-w-[1280px] mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-0 relative">
        <div className="relative z-10 lg:pr-12">
          <div className="relative rounded-xl overflow-hidden shadow-[0_25px_60px_-25px_rgba(20,17,15,0.4)]">
            <img src={comfortImage} alt="Tax planning" className="w-full h-[460px] object-cover" />
          </div>
          <div className="absolute -bottom-10 right-2 lg:-right-8 w-72 rounded-xl overflow-hidden border-[6px] border-white shadow-[0_18px_40px_-18px_rgba(20,17,15,0.45)]">
            <img src={comfortImageSmall} alt="Meeting" className="w-full h-40 object-cover" />
          </div>
        </div>

        <div className="bg-[#4a2e1a] text-white rounded-xl p-10 md:p-14 lg:-ml-20 lg:mt-16 relative shadow-[0_30px_60px_-30px_rgba(74,46,26,0.6)]">
          <div className="absolute -top-3 -right-3 w-32 h-32 rounded-full bg-[#f5b300]/15 blur-2xl" />
          <h2 className="text-[32px] md:text-[40px] leading-[1.15] font-extrabold text-white">
            {t('comfort.titlePre')} <span className="text-[#f5b300]">{t('comfort.titleAccent')}</span> {t('comfort.titlePost')}
          </h2>
          <p className="mt-5 text-white/75 text-[15px] leading-relaxed">{t('comfort.desc')}</p>

          <div className="mt-8 space-y-4">
            {features.map((f) => (
              <div key={f.t} className="flex items-start gap-4">
                <div className="w-11 h-11 rounded-md bg-[#f5b300] flex items-center justify-center shrink-0">
                  <f.icon className="w-5 h-5 text-[#14110f]" strokeWidth={2} />
                </div>
                <div>
                  <p className="text-white font-semibold text-[15px]">{f.t}</p>
                  <p className="text-white/65 text-[13.5px]">{f.d}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-10 flex justify-center">
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 bg-[#f5b300] hover:bg-[#e0a200] text-[#14110f] font-semibold px-8 py-3.5 rounded-md shadow-[0_14px_30px_-10px_rgba(245,179,0,0.7)] hover:-translate-y-0.5 transition-all"
            >
              <Mail className="w-4 h-4" /> {t('cta.contactUs')}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
